<template>
  <div>
    <section class="title-box">
      <div class="container">
        <h1>{{ $t("學生卡延展") }}</h1>
      </div>
    </section>
    <!-- 基本資料 -->
    <section class="basic">
      <div class="container">
        <div class="information-box">
          <h2>{{ $t("基本資料") }}</h2>
          <hr />
          <div class="form-group">
            <label for="expire">{{ $t("畢業年份") }}</label>
            <select class="form-control" id="expire">
              <option v-for="n in 10" :key="n">
                {{ currentYear + n }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="school">{{ $t("就讀學校") }}</label>
            <input
              type="text"
              class="form-control"
              placeholder=""
              id="school"
            />
          </div>
        </div>
      </div>
    </section>
    <hr class="line" />
    <section class="">
      <div class="container">
        <div class="information-box">
          <h2>{{ $t("學生證正面") }}</h2>
          <hr />
          <div
            class="box img-preview"
            data-for="stu_img"
            id="stu_img_preview"
            style="
              display: none;
              background-repeat: no-repeat;
              background-position-x: center;
              background-position-y: center;
              background-size: contain;
            "
          ></div>
          <input type="hidden" value="" id="stu_img_data" />
          <div class="box" id="stu_img_def">
            <p>
              {{
                $t(
                  "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。"
                )
              }}
            </p>
            <div class="custom-file">
              {{ $t("選擇檔案") }}
              <input
                type="file"
                class="custom-file-input"
                accept="image/jpg, image/jpeg, image/png"
                id="stu_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr class="line" />
    <section class="">
      <div class="container">
        <div class="information-box">
          <h2>{{ $t("學生證反面") }}</h2>
          <hr />
          <div
            class="box img-preview"
            data-for="stu_imgf"
            id="stu_imgf_preview"
            style="
              display: none;
              background-repeat: no-repeat;
              background-position-x: center;
              background-position-y: center;
              background-size: contain;
            "
          ></div>
          <input type="hidden" value="" id="stu_imgf_data" />
          <div class="box" id="stu_imgf_def">
            <p>
              {{
                $t(
                  "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。"
                )
              }}
            </p>
            <div class="custom-file">
              {{ $t("選擇檔案") }}
              <input
                type="file"
                class="custom-file-input"
                accept="image/jpg, image/jpeg, image/png"
                id="stu_imgf"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Section class="done-btn">
      <button @click="handleExtendedTime()">{{ $t("提交") }}</button>
    </Section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "學生效期延展": "學生效期延展",
    "基本資料": "基本資料",
    "畢業年份": "畢業年份",
    "就讀學校": "就讀學校",
    "學生證正面": "學生證正面",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。": "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。",
    "選擇檔案": "選擇檔案",
    "學生證反面": "學生證反面",
    "提交": "提交",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "請上傳學生證正面照片": "請上傳學生證正面照片",
    "確定": "確定",
    "請上傳學生證反面照片": "請上傳學生證反面照片",
    "延展申請成功": "延展申請成功",
    "即將返回首頁": "即將返回首頁",
  },
  en: {
    "學生效期延展": "Extension of student card",
    "基本資料": "Basic info",
    "畢業年份": "Year of graduation",
    "就讀學校": "School attended",
    "學生證正面": "The front of student card",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。": "Format: the file can only be in JPG and PNG format, with the size smaller than 1MB. The photos must be clear and recognizable.",
    "選擇檔案": "Select the file",
    "學生證反面": "The back of student card",
    "提交": "Submit",
    "請稍候...": "Wait a second",
    "錯誤": "Error",
    "請上傳學生證正面照片": "Please upload the front photo of your student card",
    "確定": "Confirm",
    "請上傳學生證反面照片": "Please upload the back photo of your student card",
    "延展申請成功": "Thank you",
    "即將返回首頁": "Will return to the home page",
  },
  jp: {
    "學生效期延展": "學生效期延展",
    "基本資料": "基本資料",
    "畢業年份": "畢業年份",
    "就讀學校": "就讀學校",
    "學生證正面": "學生證正面",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。": "格式：檔案僅接受jpg、png格式圖片檔，並小於1MB，照片需清晰且可辨認。",
    "選擇檔案": "選擇檔案",
    "學生證反面": "學生證反面",
    "提交": "提交",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "請上傳學生證正面照片": "請上傳學生證正面照片",
    "確定": "確定",
    "請上傳學生證反面照片": "請上傳學生證反面照片",
    "延展申請成功": "延展申請成功",
    "即將返回首頁": "即將返回首頁",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "ExtendedTime",
  i18n,
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  created: function () {},
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("card");
    $(".wrapper").addClass("card-information-1");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }

    var that = this;

    $(".img-preview").on("click", function () {
      var id = $(this).data("for");
      $("#" + id).click();
    });

    $(".custom-file-input").change(function () {
      // 顯示請稍候
      that.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      var id = $(this).attr("id");
      lrz(this.files[0])
        .then(function (rst) {
          //console.log(rst.base64);
          $("#" + id + "_preview").css(
            "background-image",
            'url("' + rst.base64 + '")'
          );
          $("#" + id + "_data").val(rst.base64);
          $("#" + id + "_def").hide();
          $("#" + id + "_preview").show();
        })
        .catch(function (err) {})
        .always(function () {
          that.$swal.close();
        });
    });
  },
  updated: function () {},
  methods: {
    handleExtendedTime() {
      let that = this;

      if ($("#stu_img_data").val() == "") {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("請上傳學生證正面照片"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
        return;
      }
      if ($("#stu_imgf_data").val() == "") {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("請上傳學生證反面照片"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
        return;
      }

      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/ExtendedTime",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          expire: $("#expire").val(),
          school: $("#school").val(),
          stu_img_data: $("#stu_img_data").val(),
          stu_imgf_data: $("#stu_imgf_data").val(),
        },
        dataType: "json",
        error: function () {},
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("延展申請成功"),
              text: that.$t("即將返回首頁"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                // 轉到首頁
                that.$router.push("/");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}
.vue-tel-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ExtendedTime.vue